module.exports = __webpack_public_path__ + "static/media/kyc.96dc8253.png";